module.exports = __webpack_public_path__ + "img/1 (20).9836d9f5.png";